import { Fragment, MutableRefObject, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { alertActions } from '../../_actions/alert.actions'
import animation_folder from '../../assets/05_Traverse_Folder_Lock.json';
import Lottie from 'lottie-react';
import { useHistory } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import { User } from '../../proto/user';

type Props = {
    displaySuccessAlert: any,
    displayErrorAlert: any,
    history: any
}

const EmailValidation = (props: Props) => {
    const history = useHistory();
    const user: MutableRefObject<User> = useRef(props.history?.location?.state?.user);

    useEffect(() => {
        if (!user.current || !user.current.email) {
            history.push('/')
        }
    }, [user.current])

    return <Fragment>
        <div className="AppContent">
            {(!user || !user.current) &&
                <CircularProgress color="primary" />
            }
            {(user.current && user.current.email) && <div className="InfoContainer">
                <div className="InfoImage">
                    <Lottie loop={false} animationData={animation_folder} />
                </div>
                <div className="FormContent">
                    <div className="FormTitle">
                        Create Your Account
                    </div>
                    <div className="FormDetails">
                        Thank you for your interest in Traverse! We sent a verification email to you at <span style={{fontWeight: 'bold'}}>{user.current.email}</span>. Please check your inbox and click the link in the verification email to confirm your Traverse account.
                    </div>
                </div>
            </div>
            }
        </div>
    </Fragment>
}

const mapState = (state: any) => { return {}; }

const actionCreators = {
    displayErrorAlert: alertActions.error,
    displaySuccessAlert: alertActions.success
};

const connectedApp = connect(mapState, actionCreators)(EmailValidation);

export { connectedApp as EmailValidation };